import React from 'react';
import { A } from 'hookrouter';
import { useTranslation } from 'react-i18next';
import { OFFICE_DETAILS_BOSS_NAME_LABEL, OFFICE_DETAILS_NAME_LABEL, OFFICE_DETAILS_IN_SHAREPOINT_LABEL, OFFICE_DETAILS_TOTAL_CONSULTANTS_LABEL, OFFICE_DETAILS_TOTAL_EMPLOYEES_LABEL } from '../../i18n/keyConstants';

const OfficeInfo = ({ office }) => {
    const { t } = useTranslation(['officeDetails']);

    const bossName = office.bossName || office.bosEmpID;

    return (
        <div className='container margin-top-15px employee-info'>
            <div className='row'>
                <div className='col-lg-3 col-6'>
                    <label>{t(OFFICE_DETAILS_NAME_LABEL)}</label>
                    <p>
                        {office.nam}
                        {office.sharepointLink && (
                            <>
                                <br />
                                <p class="font-italic">
                                    <a href={office.sharepointLink} target="_blank" rel="noopener noreferrer">{t(OFFICE_DETAILS_IN_SHAREPOINT_LABEL)}</a>
                                </p>
                            </>
                        )}
                    </p>

                    {office.bosEmpID && (
                        <>
                            <label>{t(OFFICE_DETAILS_BOSS_NAME_LABEL)}</label>
                            <p>
                                <A href={`/employee/${office.bosEmpID}/info`}>{bossName}</A>
                            </p>
                        </>
                    )}
                </div>
                <div className='col-lg-3 col-6'>
                    <label>{t(OFFICE_DETAILS_TOTAL_EMPLOYEES_LABEL)}</label>
                    <p>
                        {office.totalEmployees}
                    </p>
                    <label>{t(OFFICE_DETAILS_TOTAL_CONSULTANTS_LABEL)}</label>
                    <p>
                        {office.totalConsultants}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default OfficeInfo;
